import Breadcrumb from 'shopper/components/Breadcrumb/V2';
import Icon from 'shopper/components/Icon';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const CouponBreadcrumb = () => (
  <Breadcrumb.Root>
    <Breadcrumb.Item
      aria-label="Ir para página inicial"
      icon={<Icon name="home" />}
      link={LINKS.HOME}
    />
    <Breadcrumb.Item>{placeholder('breadcrumbs.couponsHome')}</Breadcrumb.Item>
  </Breadcrumb.Root>
);

export default CouponBreadcrumb;
